import Icon from 'veui/components/Icon'

Icon.register({
  check: {
    paths: [
      {
        d: 'M44.6 8.58a2 2 0 012.8 2.84l-29.33 29a2 2 0 01-2.8 0L.58 25.92a2 2 0 012.82-2.84l13.26 13.1 27.92-27.6z'
      }
    ],
    width: '48',
    height: '48'
  }
})
